import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      maxLength={10}
      thousandSeparator={'.'}
      decimalSeparator={','}
      isNumericString={true}
      prefix="B$ "
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function InputMoney({ ...props }) {
  const [values, setValues] = React.useState({ numberformat: '' });

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    if (props.setValue) {
      props.setValue(event.target.value);
    }
  };

  return (
    <TextField
      autoFocus={props.autoFocus || false}
      error={props.error || false}
      fullWidth={props.fullWidth || true}
      helperText={props.helperText || ''}
      id={props.id || 'InputMoney'}
      label={props.label || ''}
      name={'numberformat'}
      onChange={handleChange}
      onFocus={props.onFocus || undefined}
      onKeyPress={props.onKeyPress || undefined}
      onKeyDown={props.onKeyDown || undefined}
      value={values.numberformat}
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
    />
  );
}
